import React, { FC } from 'react';
import { TRIP_STATUS } from 'utils/constants';
import { ENUM_TRIP_STATUS } from 'utils/enum';

export type TripStatusType = {
  type: ENUM_TRIP_STATUS;
};

const TripStatus: FC<TripStatusType> = ({ type }) => {
  const { bgColor, borderColor, text, textColor } = TRIP_STATUS[type];
  return (
    <div
      style={{
        backgroundColor: bgColor,
        borderColor: borderColor,
        color: textColor
      }}
      className={`border-[1.5px] rounded-[40px] text-xs leading-[19px] min-w-[80px] text-center px-4 py-1`}>
      {text}
    </div>
  );
};

export default TripStatus;
